/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The role types:
 *   * TECHNICAL : role for technical users
 *   * MANAGEMENT : role for management users
 *   * CLIENT : role for management on the client's side
 */
export enum RoleType {
  TECHNICAL = 'TECHNICAL',
  MANAGEMENT = 'MANAGEMENT',
  CLIENT = 'CLIENT'
}
